module.exports = __webpack_public_path__ + "img/3.d3477153.png";